import { Box } from '@chakra-ui/react'
import { Button } from 'uikit'
import { useBoolean } from 'react-use'
import { Form, Modal, TextAreaForm } from 'uikit'
import { Field, Formik } from 'formik'
import * as Yup from 'yup'
import { useRemoveUser } from './services/useRemoveUser'

const validationSchema = Yup.object({
  userComment: Yup.string().required('Обязательное поле'),
})

export const DisactivateUser = ({ userId }) => {
  const { mutate, isLoading } = useRemoveUser(userId)
  const [isOpen, setOpenModal] = useBoolean(false)

  const onSubmitHandle = (values) => {
    mutate(values)
  }

  return (
    <>
      <Button width="100%" onClick={() => setOpenModal(true)} colorPalette="orange" loading={isLoading}>
        Деактивировать
      </Button>
      <Modal isOpen={isOpen} onClose={() => setOpenModal(false)} title="Деактивировать пользователя">
        <Formik
          validateOnMount
          enableReinitialize
          initialValues={{}}
          validationSchema={validationSchema}
          onSubmit={onSubmitHandle}
        >
          {({ handleSubmit, isValid }) => (
            <Form w="full">
              <Field
                disabled={isLoading}
                name="userComment"
                placeholder="Введите комментарий"
                component={TextAreaForm}
              />
              <Box pt="30px">
                <Button
                  colorPalette="orange"
                  loading={isLoading}
                  onClick={handleSubmit}
                  disabled={!isValid}
                >
                  Деактивировать
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  )
}
